'use client'

import { useAsset } from '@marketplace-web/shared/assets'
import { PrivacyCardModel } from '@marketplace-web/user-agreements/privacy-center-data'

const usePrivacyAtGlanceCardContent = () => {
  const asset = useAsset('/assets/privacy-center/manage-data-section')

  const cardDataCollected = asset('IllustrationDataCollected.jpg')
  const cardDataUsed = asset('IllustrationDataUse.jpg')
  const cardDataShared = asset('IllustrationDataSharing.jpg')

  const manageDataSectionCards: Array<PrivacyCardModel> = [
    {
      imageSrc: cardDataCollected,
      title: 'privacy_center.manage_data_section.data_collected.title',
      description: 'privacy_center.manage_data_section.data_collected.description',
      link: 'privacy_center.manage_data_section.data_collected.link',
      link_a11y: 'privacy_center.manage_data_section.data_collected.link_a11y',
    },
    {
      imageSrc: cardDataUsed,
      title: 'privacy_center.manage_data_section.data_used.title',
      description: 'privacy_center.manage_data_section.data_used.description',
      link: 'privacy_center.manage_data_section.data_used.link',
      link_a11y: 'privacy_center.manage_data_section.data_used.link_a11y',
    },
    {
      imageSrc: cardDataShared,
      title: 'privacy_center.manage_data_section.data_shared.title',
      description: 'privacy_center.manage_data_section.data_shared.description',
      link: 'privacy_center.manage_data_section.data_shared.link',
      link_a11y: 'privacy_center.manage_data_section.data_shared.link_a11y',
    },
  ]

  return manageDataSectionCards
}

export default usePrivacyAtGlanceCardContent
